<template>
  <div class="error">
    An error occurred while trying to update your selection(s). Please try again. If the issue
    continues, please contact our support team at
    <a class="inline-link" :href="`tel:${hrefTFN}`">{{ tollFreeNumber }}</a
    >.
  </div>
</template>
<script setup lang="ts">
import { useStore } from "vuex";
import { computed } from "vue";

const store = useStore();

const hrefTFN = computed<string>(() => {
  return store.state.lenderData && store.state.lenderData.tollFreeNumber
    ? `+${store.state.lenderData.tollFreeNumber.replace(/-/g, "")}`
    : "N/A";
});
const tollFreeNumber = computed<string>(() => {
  return store.state.lenderData && store.state.lenderData.tollFreeNumber
    ? store.state.lenderData.tollFreeNumber
    : "N/A";
});
</script>
<style scoped>
.error,
.error a {
  color: #8b0e04;
}

.error a {
  text-decoration: underline;
  cursor: pointer;
}
</style>
